import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

export default function MeetYolanda({ config }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section
      id="founder"
      ref={ref}
      className="relative bg-black text-white py-24 md:py-40 border-t border-white/10 overflow-hidden"
      data-testid="meet-yolanda-section"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-6 md:gap-10">
          <div className="col-span-12 md:col-span-5 order-2 md:order-1">
            <div className="relative aspect-[3/4] md:aspect-[4/5] w-full overflow-hidden rounded-t-[999px] bg-black border border-white/10">
              <motion.div style={{ y: imgY }} className="absolute inset-0">
                <img
                  src="/gallery/yolanda-portrait.jpg"
                  alt="Yolanda Campbell — Founder, Master Cosmetologist, Barber"
                  className="w-full h-full object-cover"
                  style={{ objectPosition: "center top" }}
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent" />
              </motion.div>
              <div className="absolute bottom-6 left-6 right-6 z-10">
                <div className="eyebrow text-white/80">Founder / Master Cosmetologist / Barber</div>
                <div className="font-serif text-3xl md:text-4xl mt-2 leading-tight">
                  Yolanda Campbell
                </div>
              </div>
            </div>

            <div className="mt-6 border-t border-white/10 pt-6 grid grid-cols-3 gap-4">
              <div>
                <div className="font-serif text-4xl md:text-5xl">25+</div>
                <div className="eyebrow text-zinc-500 mt-1">Years Cutting</div>
              </div>
              <div>
                <div className="font-serif text-4xl md:text-5xl">2021</div>
                <div className="eyebrow text-zinc-500 mt-1">Re-opened</div>
              </div>
              <div>
                <div className="font-serif text-4xl md:text-5xl">ATL</div>
                <div className="eyebrow text-zinc-500 mt-1">Since 2000</div>
              </div>
            </div>
          </div>

          <div className="col-span-12 md:col-span-7 md:pl-10 order-1 md:order-2">
            <div className="eyebrow mb-6">§ Meet Yolanda</div>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9 }}
              className="font-serif text-4xl sm:text-5xl md:text-7xl leading-[0.95] tracking-tight"
            >
              Long Island roots.
              <br />
              <span className="italic text-zinc-400">Atlanta craft.</span>
            </motion.h2>

            <div className="mt-10 space-y-6 text-zinc-300 text-base md:text-lg leading-relaxed max-w-xl">
              <p>
                Yolanda Campbell brings more than 25 years of experience in the hair industry to She Cuts Barber Studio. Originally from Long Island, New York, she developed her passion for cutting and working with all hair textures through her work with Dudley's, where she taught advanced clipper techniques.
              </p>
              <p>
                After moving to Georgia in 2000, she built her career in Atlanta and eventually became the owner of the shop where she had worked for nearly 15 years. After that location closed, Yolanda reopened She Cuts Barber Studio in April 2021 — rebuilding her business with faith, perseverance, and the continued support of her clients.
              </p>
              <p>
                Today, She Cuts represents more than a haircut. It is a space built around great hair services, relaxation, positive energy, personal attention, and genuine connection.
              </p>
            </div>

            <blockquote className="mt-12 md:mt-16 border-l-2 border-white pl-6 max-w-xl">
              <p className="font-serif italic text-2xl md:text-3xl leading-snug">
                “You own it. You live it. Every cut is a piece of that philosophy.”
              </p>
              <cite className="eyebrow not-italic block mt-4 text-zinc-500">
                — Yolanda Campbell, Founder
              </cite>
            </blockquote>

            <div className="mt-10 flex flex-wrap gap-3">
              <a
                href={config.voyageatl_url}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-ghost"
                data-testid="founder-voyage-link"
              >
                Read her VoyageATL feature
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
